import { render, staticRenderFns } from "./SubscriptionModal.vue?vue&type=template&id=197fc4f8&"
import script from "./SubscriptionModal.vue?vue&type=script&lang=js&"
export * from "./SubscriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports